import { sections, additional, qa } from '@/mocks/audit'

const data = {
  namespaced: true,
  state: {
    sections: [...Reflect.ownKeys(sections)]
  },
  mutations: {
    REFRESH_SECTIONS(state) {
      this.sections = { ...sections, additional, qa }
    }
  },
  actions: {
  },
  getters: {
    sections: state => state.sections
  }
}

export default data
